<script>
import Tittel from "./Tittel";
export default Tittel;
</script>
